import React, { startTransition } from 'react';
import ReactDOM from 'react-dom';
import { createRoot } from 'react-dom/client';

const MAJOR_VERSION = parseInt(React.version.split('.')[0], 10);

const ReactDOMCompat = {
    // 代理createRoot方法
    createRoot: (container: any, options: any = {}) => {
        if (MAJOR_VERSION >= 18) {
            return createRoot(container, options);
        }

        // React 16的兼容实现
        return {
            render: (children: any) => ReactDOM.render(children, container),
            unmount: () => ReactDOM.unmountComponentAtNode(container),
            _hasLegacyRoot: true
        };
    },

    // 代理startTransition方法
    startTransition: (callback: any) => {
        if (MAJOR_VERSION >= 18) {
            return startTransition(callback);
        } else {
            callback();
        }

        // React 16的降级实现
        // if (ReactDOM.unstable_batchedUpdates) {
        //     ReactDOM.unstable_batchedUpdates(callback);
        // } else {
        //     callback();
        // }
    },

    // 代理flushSync方法
    flushSync: (callback: any) => {
        if (MAJOR_VERSION >= 18) {
            return ReactDOM.flushSync(callback);
        }

        // React 16的同步实现
        // if (ReactDOM.unstable_deferredUpdates) {
        //     return ReactDOM.unstable_deferredUpdates(callback);
        // }
        return callback();
    }
};

// 代理其他需要兼容的方法
// const createProxy = (methodName) => (...args) => {
//     if (MAJOR_VERSION >= 18) {
//         return ReactDOM[methodName](...args);
//     }
//     // 添加针对旧版本的特别处理
//     return ReactDOM[methodName](...args);
// };

// ['hydrate', 'findDOMNode', 'unmountComponentAtNode'].forEach(method => {
//     ReactDOMCompat[method] = createProxy(method);
// });

export default ReactDOMCompat;